import { render, staticRenderFns } from "./InfoTableGeneral.vue?vue&type=template&id=4a155b9c&scoped=true"
import script from "./InfoTableGeneral.vue?vue&type=script&lang=js"
export * from "./InfoTableGeneral.vue?vue&type=script&lang=js"
import style0 from "./InfoTableGeneral.vue?vue&type=style&index=0&id=4a155b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a155b9c",
  null
  
)

export default component.exports